import { DrawingToolHelpers } from "../../../helpers/drawing-tool-helpers";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from ".././drawing-tool.interface";
import { DrawingToolsManager } from ".././drawing-tools.manager";

export class VerticalCounterComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): VerticalCounterComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
         
        annotationOptions.typeOptions.point.x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.point.actualXValue,
            annotationOptions.typeOptions.point.actualStartTimeT,
            drawingToolManager);

        const component = new VerticalCounterComponent(drawingToolManager, annotationOptions.id);
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): VerticalCounterComponent {
        const component = new VerticalCounterComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {
        if (!annotationOptions?.typeOptions?.point) {
            return;
        }

        annotationOptions.typeOptions.point.x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.point.actualXValue,
            annotationOptions.typeOptions.point.actualStartTimeT,
            this.drawingToolManager);

    }

    public getMetaData(): any {
        if (!this.annotation.options?.typeOptions?.point) {
            return null;
        }

        const firstPoint = this.annotation.options.typeOptions.point;
        const actualFirstPosition = DrawingToolHelpers.getActualStartTimePosition(firstPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: "verticalCounter",
            type: 'verticalLine', // options type
            labelOptions: {
                style: {
                    color: this.annotation.options.labelOptions.style.color,
                    fontSize: this.annotation.options.labelOptions.style.fontSize
                }
            },
            shapeOptions: {
                stroke: this.annotation.options.shapeOptions.stroke,
                strokeWidth: this.annotation.options.shapeOptions.strokeWidth,
            },
            typeOptions: {
                label: {
                    offset: this.annotation.options.typeOptions.label.offset,
                    text: this.annotation.options.typeOptions.label.text
                },
                point: {
                    x: firstPoint.x,
                    actualStartTimeT: actualFirstPosition?.actualStartTimeT,
                    actualXValue: actualFirstPosition?.actualXValue,

                    y: firstPoint.y,

                    xAxis: firstPoint.xAxis,
                    yAxis: firstPoint.yAxis
                }
            }
        };
    }
}